import { render, staticRenderFns } from "./airport.vue?vue&type=template&id=684f477a&"
import script from "./airport.vue?vue&type=script&lang=js&"
export * from "./airport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports